module.exports = __webpack_public_path__ + "img/autospin_btn.ecee4035.png";